import React, { useEffect } from 'react';
import markerImageSrc from '../../assets/images/main_logo.png'; // 경로 수정
import { useNavigate } from 'react-router-dom';

const Address = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const script = document.createElement('script');
    script.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=5d499da089e61ca64970818b642c4f8e&autoload=false`;
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      const { kakao } = window;

      if (kakao && kakao.maps) {
        const mapContainer = document.getElementById('map');
        const mapOption = {
          center: new kakao.maps.LatLng(36.7894850443376, 127.107421226737),
          level: 3,
        };
        const map = new kakao.maps.Map(mapContainer, mapOption);

        // 기본 마커 설정 (이미지 없이)
        const markerPosition = new kakao.maps.LatLng(36.7894850443376, 127.107421226737);
        const marker = new kakao.maps.Marker({
          position: markerPosition,
        });

        // 마커 지도에 추가
        marker.setMap(map);
      } else {
        console.error('Kakao Maps API is not loaded');
      }
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section className="last-section">
      <div className="map-wrap">
        <div className="map-left-wrap">
          <div className="left-content">
            <h2>Contact Us</h2>
            <p>A. 충청남도 아산시 배방읍 희망로46번길 45-7, 충남글로벌게임센터 304호</p>
            <p>F. 0504-373-4873</p>
            <p>E. plassion@naver.com</p>

            <div className="map-btn-wrap">
              <div className="come-a" onClick={() => navigate('/about/intro', { state: { someKey: true } })}>
                <p>오시는 길</p>
                <div className="add1"></div>
              </div>
              <div className="come-b" onClick={() => navigate('/board/contact_us')}>
                <p>문의하기</p>
                <div className="add2"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="map-right-wrap" id="map"></div>
      </div>
    </section>
  );
};

export default Address;
